import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AttendanceService } from '../../services/attendance.service';
import { AttendanceResponseDto } from '../../interfaces/interfaces';

@Component({
  selector: 'app-attendance-dashboard',
  templateUrl: './attendance-dashboard.component.html',
  styleUrls: ['./attendance-dashboard.component.scss']
})
export class AttendanceDashboardComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = ['employeeName', 'timestamp', 'status', 'photo', 'faceVerification'];
  dataSource = new MatTableDataSource<AttendanceResponseDto>();
  
  loading = false;
  today = new Date();
  isAdmin: boolean = false;
  isAttendanceUser: boolean = false;

  constructor(
    private attendanceService: AttendanceService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.checkUserRole();
    this.loadTodayAttendance();
  }

  private checkUserRole(): void {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {
      this.isAdmin = currentUser.role === 'Admin';
      this.isAttendanceUser = currentUser.role === 'Attendance';
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadTodayAttendance(): void {
    this.loading = true;
    const today = new Date();

    this.attendanceService.getTodayAttendanceEntries().subscribe({
      next: (response) => {
        this.dataSource.data = response.attendanceEntries;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading today\'s attendance:', error);
        this.snackBar.open('Error loading today\'s attendance', 'Close', { duration: 3000 });
        this.loading = false;
      }
    });
  }

  formatDate(date: Date): string {
    // Use local date formatting to avoid timezone issues
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getStatusLabel(status: number): string {
    return status === 1 ? 'Clock In' : 'Clock Out';
  }

  getStatusClass(status: number): string {
    return status === 1 ? 'clock-in' : 'clock-out';
  }

  goToClockInOut(): void {
    this.router.navigate(['/attendance/clock-in-out']);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  refreshData(): void {
    this.loadTodayAttendance();
  }
} 